import React from 'react'
import { NextPageContext } from 'next'
import { getIsUSUser } from '@pff-consumer/utils/lib/checkout/get-is-us-user'
import { CreateAccount } from '../../components/create-account/create-account'
import ErrorBoundary from '../../components/error-boundary/error-boundary'
import { Header } from '../../components/common/header/header'
import {
  GoogleTagManagerHead,
  GoogleTagManagerHeadProps,
  getServerSidePropsForGoogleTagManager,
} from '../../utils/analytics/google'

export async function getServerSideProps({ req, res }: NextPageContext) {
  const gtmProps = await getServerSidePropsForGoogleTagManager({ req, res } as NextPageContext)
  const isUSUser = await getIsUSUser(req)

  return { props: { gtmProps, isUSUser } }
}

export default function Index({ gtmProps, isUSUser }: { gtmProps: GoogleTagManagerHeadProps; isUSUser: boolean }) {
  const { dataLayer } = gtmProps
  return (
    <ErrorBoundary>
      <GoogleTagManagerHead dataLayer={dataLayer} />
      <Header />
      <CreateAccount isUSUser={isUSUser} />
    </ErrorBoundary>
  )
}
